import React, { useState } from "react";
import "./menu.css";
import { FiArrowRight } from "react-icons/fi";

import vegbf from "../assets/menu/veg/breakFast.jpeg";
import veglunch from "../assets/menu/veg/lunch.jpg";
import vegdinner from "../assets/menu/veg/dinner.jpeg";

import nonvegbf from "../assets/menu/nonveg/breakFast.jpg";
import nonveglunch from "../assets/menu/nonveg/lunch.jpg";
import nonvegdinner from "../assets/menu/nonveg/dinner.jpg";

import veganbf from "../assets/menu/vegan/breakFast.jpg";
import veganlunch from "../assets/menu/vegan/lunch.jpg";
import vegandinner from "../assets/menu/vegan/dinner.jpg";

import eggbf from "../assets/menu/egg/breakFast.jpeg";
import egglunch from "../assets/menu/egg/lunch.jpg";
import eggdinner from "../assets/menu/egg/dinner.jpg";

import SwiperSlideComponent from "./SwiperSlideComponent";

const menuData = {
  Veg: {
    Breakfast: { image: vegbf, description: "Overnight Oats Bowl" },
    Lunch: { image: veglunch, description: "Paneer Millet Bowl" },
    Dinner: { image: vegdinner, description: "Grilled PaneerSalad" },
  },
  NonVeg: {
    Breakfast: { image: nonvegbf, description: "American Breakfast" },
    Lunch: { image: nonveglunch, description: "Lemon ProteinBowl" },
    Dinner: { image: nonvegdinner, description: "Chicken BurritoBowl" },
  },
  Vegan: {
    Breakfast: { image: veganbf, description: "Oatmeal (ND) Bowl" },
    Lunch: { image: veganlunch, description: "Mexican Dhal Bowl" },
    Dinner: { image: vegandinner, description: "Fresh Greek Salad" },
  },
  Eggterian: {
    Breakfast: { image: eggbf, description: "Egg Frittata Dish" },
    Lunch: { image: egglunch, description: "Ragi and Egg Roll" },
    Dinner: { image: eggdinner, description: "Poached Pesto Bowl" },
  },
};
const FoodMenu = () => {
  const [selectedType, setSelectedType] = useState("Veg");

  return (
    <div className="main global" id="menu">
      <div className="menu">
        <h2>Bhookr's Menu</h2>
        {/* <h3 className="text-[20px] text-[#de0101]">Type of Food we Serve</h3> */}
        <SwiperSlideComponent />

        <h4>A day meal in bhookr</h4>
        <div className="typeoffood">
          {Object.keys(menuData).map((type) => (
            <button
              key={type}
              style={{
                backgroundColor: selectedType === type ? "#de0101" : "#fff",
                color: selectedType === type ? "white" : "black",
              }}
              onClick={() => setSelectedType(type)}
            >
              {type}
            </button>
          ))}
        </div>
        <div className="menusub">
          {Object.entries(menuData[selectedType]).map(([meal, details]) => (
            <div key={meal} className="meal">
              <div className="foodcard">
                <img
                  src={details.image}
                  alt={`${selectedType} ${meal}`}
                  loading="lazy"
                />
                <h6>{details.description}</h6>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="easyhilights">
        <div>
          <svg
            width=""
            height=""
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="foodsvg"
          >
            <path
              d="M38 46L6 43V5L38 2V46Z"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M44 6V42"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 29H29"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 36L29 37"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 22C24.3137 22 27 19.3137 27 16C27 12.6863 24.3137 10 21 10C17.6863 10 15 12.6863 15 16C15 19.3137 17.6863 22 21 22Z"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <h4>Multi Cuisine</h4>
        </div>
        <div>
          <svg
            width=""
            height=""
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="foodsvg"
          >
            <path
              d="M38 22H10V38H38V22Z"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M31 28H17"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M29 12C30.1046 12 31 11.1046 31 10C31 8.89543 30.1046 8 29 8C27.8954 8 27 8.89543 27 10C27 11.1046 27.8954 12 29 12Z"
              fill="#fff"
            />
            <path
              d="M37 12C38.1046 12 39 11.1046 39 10C39 8.89543 38.1046 8 37 8C35.8954 8 35 8.89543 35 10C35 11.1046 35.8954 12 37 12Z"
              fill="#fff"
            />
            <path
              d="M40 4H8C5.79086 4 4 5.79086 4 8V40C4 42.2091 5.79086 44 8 44H40C42.2091 44 44 42.2091 44 40V8C44 5.79086 42.2091 4 40 4Z"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 10H16"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 16H44"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <h4>Easy To Order</h4>
        </div>
        <div>
          <svg
            width=""
            height=""
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="foodsvg"
          >
            <path
              d="M42 28V46H6V28"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 2H31"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24 28L32.5 19.5"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24 2V5"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24 46C33.9411 46 42 37.9411 42 28C42 18.0589 33.9411 10 24 10C14.0589 10 6 18.0589 6 28C6 37.9411 14.0589 46 24 46Z"
              stroke="#131313"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24 16V18"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M36 28H34"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32.485 36.485L31.071 35.071"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24 40V38"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5149 36.485L16.9289 35.071"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 28H14"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5149 19.515L16.9289 20.929"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <h4>Fast Delivery</h4>
        </div>
      </div>
    </div>
  );
};

export default FoodMenu;
